/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { Link } from 'react-router-dom';

import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Eye, EyeOff } from 'lucide-react';

import Card from './Card';
import Store from './Store';
import useCurrentUser from './useCurrentUser';
import UpdateUserMutation from '../mutations/UpdateUserMutation';

let Profile = ({ viewer }) => {
  const [displayName, setDisplayName] = React.useState(viewer.displayName);
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  let devices = () => {
    return viewer.devices.edges.map(edge => {
      return (
        <div key={edge.node.id}>
          <div>
            <div>
              {' '}
              {edge.node.id} {edge.node.name}
            </div>
          </div>
        </div>
      );
    });
  };

  let onSave = () => {
    UpdateUserMutation.commit(displayName, null, null, () => {
      Store.setSuccess('Saved');
    });
  };

  const hasDevice = viewer.devices.edges.length > 0;
  const [currentUser] = useCurrentUser();

  return (
    <div className="grid grid-cols-12 gap-4">
      {currentUser.isAnonymous && (
        <div className="col-span-12">
          <Card>
            <div className="mb-4">
              <p className="mb-2">Finish setting up your account and devices</p>
              <div>
                <Button asChild>
                  <Link to="/finish_setup">Finish setup</Link>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )}
      <div className="col-span-12">
        <Card className="p-4">
          <h2 className="text-2xl font-semibold mb-4">Profile</h2>
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <Label className="w-32">User ID</Label>
              <span>{viewer.id}</span>
            </div>
            <div className="flex items-center gap-4">
              <Label className="w-32">Email</Label>
              <span>{viewer.email}</span>
            </div>
            <div className="flex items-center gap-4">
              <Label htmlFor="display-name" className="w-32">
                Display Name
              </Label>
              <Input
                id="display-name"
                onChange={e => setDisplayName(e.target.value)}
                value={displayName}
                className="w-[240px]"
              />
            </div>
            <div className="flex items-center gap-4">
              <Label htmlFor="access-token" className="w-32">
                Access Token
              </Label>
              <div className="relative flex-1 max-w-md">
                <Input
                  id="access-token"
                  readOnly
                  type={showPassword ? 'text' : 'password'}
                  value={viewer.accessToken.secret}
                  className="pr-10 min-w-[300px]"
                />
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  className="absolute right-0 top-0 h-full"
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeOff className="h-4 w-4" />
                  ) : (
                    <Eye className="h-4 w-4" />
                  )}
                </Button>
              </div>
            </div>
          </div>
          <Button className="mt-4" onClick={onSave} disabled={loading}>
            Save
          </Button>
          {viewer.subscribed === 'subscribed' && (
            <div className="col-span-12 mt-4">
              <Card className="p-4">
                <h2 className="text-2xl font-semibold mb-2">Subscribed</h2>
                <p className="text-sm">
                  You are currently subscribed and get unlimited messages. To
                  unsubscribe email support@pushback.io
                </p>
              </Card>
            </div>
          )}
          {hasDevice && (
            <div className="mt-4">
              <h2 className="text-2xl font-semibold mb-2">Devices</h2>
              {devices()}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

Profile = createFragmentContainer(Profile, {
  viewer: graphql`
    fragment Profile_viewer on User {
      id
      email
      displayName
      accessToken {
        secret
      }
      subscribed
      devices(first: 100) @connection(key: "Profile_devices") {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  `,
});

export default Profile;
